<template>
  <div id="map-container" style="width: 100%; height: 200px"></div>
</template>

<script>
export default {
  name: "TencentMap",
  props: {
    // 地图中心
    center: {
      type: Object,
      default: () => ({ lat: 39.90923, lng: 116.397428 }),
    },
    // 外部传入要打标记的位置：{ lat: Number, lng: Number }
    markerPosition: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      map: null, // TMap.Map 实例
      marker: null, // TMap.Marker 实例
      mapInfo: null, // 后端返回的地图配置，包括 api_key
      locationDot: null, // CustomOverlay 实例
    };
  },
  watch: {
    markerPosition: {
      handler(newVal) {
        if (newVal) {
          this.addMarker(newVal);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getMapInfo();
  },
  beforeDestroy() {
    if (this.marker) {
      this.marker.setMap(null);
    }
    if (this.map) {
      this.map.destroy();
    }
  },

  methods: {
    // 从后台拿 key
    async getMapInfo() {
      try {
        const res = await this.axios.get(
          "/api/common/shop/admin/map/setting/index"
        );
        if (res.code === 200) {
          this.mapInfo = res.data;
          await this.loadScript();
          this.initMap();
        }
      } catch (err) {
        console.error("获取地图配置失败：", err);
      }
    },

    // 动态注入腾讯地图脚本
    loadScript() {
      return new Promise((resolve, reject) => {
        if (window.TMap) return resolve();
        const script = document.createElement("script");
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${this.mapInfo.api_key}`;
        script.onload = resolve;
        script.onerror = () => reject(new Error("腾讯地图脚本加载失败"));
        document.head.appendChild(script);
      });
    },

    // 初始化地图
    initMap() {
      this.map = new window.TMap.Map(document.getElementById("map-container"), {
        center: new window.TMap.LatLng(this.center.lat, this.center.lng),
        zoom: 12,
      });
      // 如果 mounted 的时候父组件就传了 markerPosition，也立刻打一次
      if (this.markerPosition) {
        this.addMarker(this.markerPosition);
      }
    },

    addMarker({ lat, lng }) {
  // 确保使用window全局对象引用
  const TMap = window.TMap
  
  // 先清除旧标记
  if (this.marker) {
    this.marker.setMap(null)
    this.marker = null
  }

  // 创建新标记（使用MultiMarker API更稳定）
  this.marker = new TMap.MultiMarker({
    map: this.map,
    styles: {
      marker: new TMap.MarkerStyle({
        width: 20,  // 根据实际图标尺寸调整
        height: 30,
        anchor: { x: 10, y: 30 }, // 锚点位置
        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
      })
    },
    geometries: [{
      position: new TMap.LatLng(lat, lng)
    }]
  })

  // 平移到标记位置
  this.map.panTo(new TMap.LatLng(lat, lng))
},
    // 地址转坐标示例
    async geocodeAddress(address) {
      const result = await this.$jsonp(
        "https://apis.map.qq.com/ws/place/v1/suggestion",
        {
          keyword: address,
          key: this.mapInfo.api_key,
          output: "jsonp",
        }
      );
      this.$emit("getQuerySearch", result.data);
    },
  },

  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>
<style lang="scss" scoped>
/* 加到你的组件样式里 */
.current-location-dot {
  width: 12px;
  height: 12px;
  border: 2px solid #007aff;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
}
</style>
